import { useState, useEffect } from "react";
import type { DeliveryReportRequest } from "../../api/reports";
import type { Campaign } from "../../api/campaigns";
import type { Team } from "../../api/teams";
import "./report-filters.css";

interface ReportFiltersProps {
    filters: DeliveryReportRequest;
    onFiltersChange: (filters: DeliveryReportRequest) => void;
    campaigns: Campaign[];
    teams: Team[];
}

export const ReportFilters = ({
    filters,
    onFiltersChange,
    campaigns,
    teams,
}: ReportFiltersProps): JSX.Element => {
    const [localFilters, setLocalFilters] = useState<DeliveryReportRequest>(filters);

    useEffect(() => {
        setLocalFilters(filters);
    }, [filters]);

    const handleChange = (name: keyof DeliveryReportRequest, value: string | undefined) => {
        const newFilters = { ...localFilters, [name]: value || undefined };
        setLocalFilters(newFilters);
    };

    const handleApply = () => {
        onFiltersChange(localFilters);
    };

    const handleReset = () => {
        const emptyFilters: DeliveryReportRequest = {};
        setLocalFilters(emptyFilters);
        onFiltersChange(emptyFilters);
    };

    return (
        <div className="report-filters">
            <h3>Filter</h3>
            <div className="report-filters__grid">
                <div className="report-filters__field">
                    <label htmlFor="filter-team">Team</label>
                    <select
                        id="filter-team"
                        value={localFilters.teamId || ""}
                        onChange={(e) => handleChange("teamId", e.target.value)}
                    >
                        <option value="">Alla teams</option>
                        {teams.map((team) => (
                            <option key={team.id} value={team.id}>
                                {team.name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="report-filters__field">
                    <label htmlFor="filter-campaign">Kampanj</label>
                    <select
                        id="filter-campaign"
                        value={localFilters.campaignId || ""}
                        onChange={(e) => handleChange("campaignId", e.target.value)}
                    >
                        <option value="">Alla kampanjer</option>
                        {campaigns.map((campaign) => (
                            <option key={campaign.id} value={campaign.id}>
                                {campaign.name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="report-filters__field">
                    <label htmlFor="filter-from">Från datum</label>
                    <input
                        id="filter-from"
                        type="date"
                        value={localFilters.from?.split("T")[0] || ""}
                        onChange={(e) => handleChange("from", e.target.value ? `${e.target.value}T00:00:00Z` : undefined)}
                    />
                </div>

                <div className="report-filters__field">
                    <label htmlFor="filter-to">Till datum</label>
                    <input
                        id="filter-to"
                        type="date"
                        value={localFilters.to?.split("T")[0] || ""}
                        onChange={(e) => handleChange("to", e.target.value ? `${e.target.value}T23:59:59Z` : undefined)}
                    />
                </div>
            </div>

            <div className="report-filters__actions">
                <button
                    type="button"
                    className="report-filters__button report-filters__button--apply"
                    onClick={handleApply}
                >
                    Applicera filter
                </button>
                <button
                    type="button"
                    className="report-filters__button report-filters__button--reset"
                    onClick={handleReset}
                >
                    Återställ
                </button>
            </div>
        </div>
    );
};